import { getDeviceInfo } from "helpers/utils";
import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchOnholdList(payload) {
  return await api({
    method: "get",
    params: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/onhold/onhold-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function FetchArchiveList(payload) {
  return await api({
    params: payload,
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/job/getarchiveapplications`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "", "X-lang_id": localStorage.getItem("lang_id") || "", },
  });
}

export async function FetchResourcePoolData(payload) {
  return await api({
    method: "post",
    data: { ...payload },
    url: `${process.env.REACT_APP_API_URL}/admin/job/getpooldata`,
    headers: { 
      Authorization: getUserToken(), 
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "", 
    },
  });
}

export async function applyReapplication(payload) {
  let device_info = await getDeviceInfo(navigator)
  return await api({
    method: "post",
    data: { ...payload, device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/reapplication`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}

export async function UndoArchivedApplication(payload) {
  let device_info = await getDeviceInfo(navigator)
  return await api({
    method: "post",
    data: { ...payload, device_info: device_info },
    url: `${process.env.REACT_APP_API_URL}/admin/job/undoarchiveapplication`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}

export async function RejectPendingRecord(id) {
 return await api({
   method: "put",
   data: '',
   url: `${process.env.REACT_APP_API_URL}/admin/common/reject-application/${id}`,
   headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
 });
}

export async function updatestatus(appl_id, status,comment,status_change_from) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  let device_info = await getDeviceInfo(navigator)
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/common/update-status/${appl_id}`,
    data: { status, comment, user_id, status_change_from, device_info: device_info },
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}